import Joi from '@hapi/joi'

export const bulkdeductionSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group"),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity"),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collection Category"),
    deductionTypeID: Joi.number().invalid(0).required().label("Deduction Type"),
    collectionCategoryMenuID: Joi.number().invalid(0).required().label("Collection Category Menu"),
    collectionPointID: Joi.number().required().label("Collection Point Category"),
    applyMethodID: Joi.number().invalid(0).required().label("Apply method"),
    
    minimumValue: Joi.number().positive().allow(0).required().label("MinimumValue").messages({
        "number.empty": `Minimum Value`,
        "any.required": `Please Enter Minimum Value`
    }),
    
    defaultValue: Joi.number().positive().allow(0).required().label("Default Value").messages({
        "number.empty": `Default Value`,
        "any.required": `Please Enter Default Value`
    }),
    isDefaultValueEnabled: Joi.boolean().label("Default Value Enabled"),
    isActive: Joi.boolean().label("Active"),
    isFixed:Joi.boolean().label("Active")

}















